// Mirrors Auth::change_password() in the forus API, which is the source of
// truth — it answers 422 for anything shorter or a mismatched confirmation.
export const PASSWORD_MIN_LENGTH = 8;

// Client-side pre-check for a new password, so the obvious mistakes are caught
// without a round trip. Returns an i18n key, or null when it looks valid.
export function passwordProblem(password, confirm) {
    if (password.length < PASSWORD_MIN_LENGTH) return 'password.tooShort';
    if (password !== confirm) return 'password.mismatch';
    return null;
}
